import React from 'react';

const About = () => {
  return(
    <div>Content here</div>
  )
};

export default About;


// WEBPACK FOOTER //
// ./src/components/about/About.js